import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=f59e5d36&scoped=true&"
import script from "./EditProduct.vue?vue&type=script&lang=js&"
export * from "./EditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59e5d36",
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QIcon,QTooltip,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QForm,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QIcon,QTooltip,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QForm,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
